import { NeighborsSource } from '@models/enums/components/Neighbors/NeighborsSource.enum';
import { Neighbor } from '@models/types/components/Neighbor.type';

/**
 * Resuelve el origen efectivo de los neighbors, compartido entre admin y minisite.
 *
 * Si `source` trae un valor valido del enum, se respeta tal cual (permite forzar `Seatmap`
 * aunque exista un archivo legacy subido). Si falta, se deduce por compatibilidad con configs
 * antiguas: `File` cuando `data` tiene al menos una entrada, `Seatmap` en caso contrario
 * (incluye `data` undefined o null).
 *
 * @param neighbors Objeto con las claves `source` y `data` de `Ui.Neighbors`.
 * @returns El origen efectivo: `NeighborsSource.Seatmap` o `NeighborsSource.File`.
 */
export function resolveNeighborsSource(neighbors: Pick<Neighbor, 'source' | 'data'>): NeighborsSource {
  if (isValidNeighborsSource(neighbors.source)) return neighbors.source;

  return Object.keys(neighbors.data ?? {}).length > 0
    ? NeighborsSource.File
    : NeighborsSource.Seatmap;
}

/**
 * Comprueba si un valor es uno de los miembros validos del enum `NeighborsSource`.
 *
 * @param value Valor candidato, normalmente `Ui.Neighbors.source`.
 * @returns `true` si el valor es `NeighborsSource.Seatmap` o `NeighborsSource.File`.
 */
function isValidNeighborsSource(value: unknown): value is NeighborsSource {
  return value === NeighborsSource.Seatmap || value === NeighborsSource.File;
}
